// extracted by mini-css-extract-plugin
module.exports = {"Img":"Icon_Img__2yNYl","Break":"Icon_Break__23M2z","Gmax":"Icon_Gmax__1PJeD","NoShiny":"Icon_NoShiny__9UN2H","Shiny":"Icon_Shiny__5re2c"};